import { Alert } from '@yoti/ui-kit-components-react/alert';
import React from 'react';
import styles from './alert.module.scss';

const CookiesAlert: React.FC = () => {
    return (
        <div className={styles['cookiesAlert']}>
            <Alert size="large" heading="Cookies" variation="danger" icon>
                <span data-qa="msg-text">{`We can't use your local storage to save the configuration, please enable it to save the configuration in multiple retries.`}</span>
            </Alert>
        </div>
    );
};

export default CookiesAlert;
